// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".lawyer_description-module__block--hnAhH{padding-bottom:25px;display:block;max-width:100%;word-break:break-word;max-height:none;overflow:hidden}@media screen and (max-width: 62.5625em){.lawyer_description-module__block--hnAhH{padding:0 15px 25px}}.lawyer_description-module__more--3zvty{max-height:276px}.lawyer_description-module__button--2Si-N{cursor:pointer;display:inline-block;color:#36b;margin-bottom:15px}.lawyer_description-module__button--2Si-N:hover{text-decoration:underline}\n", ""]);
// Exports
exports.locals = {
	"block": "lawyer_description-module__block--hnAhH",
	"more": "lawyer_description-module__more--3zvty",
	"button": "lawyer_description-module__button--2Si-N"
};
module.exports = exports;
